import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"check\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.778 2.712a.4.4 0 0 1 .01.566L5.39 10.913a.9.9 0 0 1-1.283.01l-2.89-2.89a.4.4 0 0 1 .565-.566l2.89 2.89a.1.1 0 0 0 .143 0l7.397-7.636a.4.4 0 0 1 .565-.009Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol